<template>
  <div class="AgentsAndNumbersView">
    <PageHeader title="Numery i Konsultanci"
                :description-in-modal="true"
                @openDescriptionModal="hintModalVisible = !hintModalVisible"
    />
    <ShPageLayout>
      <AgentsOrNumbersCardSwitchLayout>
        <AgentsList slot="agents" />
        <NumbersList slot="numbers" />
      </AgentsOrNumbersCardSwitchLayout>
    </ShPageLayout>
    <ShSideBarModal title="Dodanie nowego Konsultanta"
                    description="Wykonaj poniższe kroki aby dodać nowego Konsultanta"
                    size="750px"
                    :side-bar-modal-visibility.sync="isModalWithAddNewAgentFormVisible"
    >
      <AddNewAgentForm slot="content"
                       :number-to-be-assigned="numberToBeAssigned"
                       @closeModal="isModalWithAddNewAgentFormVisible = false"
      />
    </ShSideBarModal>
    <ShSideBarModal title="Dane Konsultanta"
                    description="Poniżej znajdują się podstawowe dane Konsultanta"
                    size="600px"
                    :side-bar-modal-visibility.sync="isModalWithAgentDataDetailsVisible"
    >
      <AgentDetails slot="content"
                    :agent="agentDetailsData"
                    @closeModal="isModalWithAgentDataDetailsVisible = false"
      />
    </ShSideBarModal>
    <ShSideBarModal title="Weryfikacja numeru telefonu"
                    :side-bar-modal-visibility.sync="isModalWithNumberVerificationVisible"
    >
      <NumberVerificationForm slot="content"
                              :verified-number="verifiedNumber"
                              @closeModal="isModalWithNumberVerificationVisible = false"
      />
    </ShSideBarModal>
    <ShModalWindow v-if="hintModalVisible"
                   @closeModal="hintModalVisible = !hintModalVisible"
    >
      <template #header>
        <img style="margin-right:10px"
             :src="require('@/assets/images/ikona-numery-konsultanci.png')"
        >
        Numery i Konsultanci
      </template>
      <template #description>
        <PopupHints hint-template-name="agentsAndNumbers" />
      </template>
    </ShModalWindow>
  </div>
</template>

<script>
import { PopupHintsUtils } from '@/mixins';
import ShPageLayout from '@/components/Helpers/ShPageLayout';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import PageHeader from '@/components/Common/PageHeader';
import PopupHints from '@/components/Common/PopupHints';
import AgentsOrNumbersCardSwitchLayout from '@/components/AgentsAndNumbers/AgentsOrNumbersCardSwitchLayout';
import AgentsList from '@/components/AgentsAndNumbers/AgentsList';
import AddNewAgentForm from '@/components/AgentsAndNumbers/AddNewAgentForm';
import AgentDetails from '@/components/AgentsAndNumbers/AgentDetails';
import NumbersList from '@/components/AgentsAndNumbers/NumbersList';
import NumberVerificationForm from '@/components/AgentsAndNumbers/NumberVerificationForm';

export default {
  name: 'AgentsAndNumbers',
  components: {
    ShPageLayout,
    ShSideBarModal,
    ShModalWindow,
    PageHeader,
    PopupHints,
    AgentsOrNumbersCardSwitchLayout,
    AgentsList,
    AddNewAgentForm,
    AgentDetails,
    NumbersList,
    NumberVerificationForm,
  },

  mixins: [PopupHintsUtils],

  data() {
    return {
      isModalWithAddNewAgentFormVisible: false,
      isModalWithAgentDataDetailsVisible: false,
      isModalWithNumberVerificationVisible: false,
      agentDetailsData: {},
      verifiedNumber: null,
      numberToBeAssigned: null,
    };
  },

  created() {
    this.mCheckInLocalStorageIfModalHasBeenAlreadyShown('agentsAndNumbersModalOpen');
    this.$EventBus.$on('NumbersListItem/CREATE_NEW_AGENT', (number) => {
      this.isModalWithAddNewAgentFormVisible = true;
      this.numberToBeAssigned = number;
    });
    this.$EventBus.$on('AgentsListItem/SHOW_AGENT_DATA', (agent) => {
      this.isModalWithAgentDataDetailsVisible = true;
      this.agentDetailsData = agent;
    });
    this.$EventBus.$on('NumbersListItem/SHOW_AGENT_DATA', (agent) => {
      this.isModalWithAgentDataDetailsVisible = true;
      this.agentDetailsData = agent;
    });
    this.$EventBus.$on('NumbersListItem/VERIFY_NUMBER', (number) => {
      this.isModalWithNumberVerificationVisible = true;
      this.verifiedNumber = number;
    });
  },

  beforeDestroy() {
    this.$EventBus.$off('NumbersListItem/CREATE_NEW_AGENT');
    this.$EventBus.$off('AgentsListItem/SHOW_AGENT_DATA');
    this.$EventBus.$off('NumbersListItem/VERIFY_NUMBER');
    this.$EventBus.$off('NumbersListItem/SHOW_AGENT_DATA');
  },
};
</script>
